import { render, staticRenderFns } from "./HistoryPointLayer.vue?vue&type=template&id=936e1528&"
import script from "./HistoryPointLayer.vue?vue&type=script&lang=js&"
export * from "./HistoryPointLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports